import i18n from 'config/i18n';
import dayjs, { Dayjs } from 'dayjs';
import minMax from 'dayjs/plugin/minMax';
import * as yup from 'yup';

import { getLocale } from 'utils/date';

dayjs.extend(minMax);

const regionalPoolEmploymentOrganisationsSchema = () => {
  const t = i18n.getFixedT(getLocale(), 'common');

  return yup.object({
    tenant: yup
      .object({
        tenantName: yup.string().required('required'),
        displayName: yup.string().required('required')
      })
      .nullable()
      .required(t('validationFieldRequired', { name: t('organization') })),
    validFrom: yup
      .mixed<Dayjs>()
      .nullable()
      .test(
        'dayjs-valid',
        () => t('invalidDate'),
        (v) => (v ? v.isValid() : false)
      )
      .required(),
    validTo: yup
      .mixed<Dayjs>()
      .nullable()
      .test(
        'dayjs-valid',
        () => t('invalidDate'),
        (v) => (v ? v.isValid() : false)
      )
      .test(
        'dayjs-min',
        () =>
          t('dateRangeMismatch', {
            startDate: t('validFrom'),
            endDate: t('validTo')
          }),
        (v, ctx) => {
          const validFrom = ctx.parent.validFrom as Dayjs;
          return v && validFrom ? v.isAfter(validFrom) : true;
        }
      )
      .required(),
    allowDay: yup.boolean().required(),
    allowNight: yup.boolean().required()
  });
};

export default regionalPoolEmploymentOrganisationsSchema;
